export const BUILDING_LOCATION_SPECIFICATION_LABEL = '家屋位置特定'
